import Box from '@mui/material/Box';

import { SOY } from 'reservations/brand/constants';
import useBrandImage from 'reservations/brand/hooks/useBrandImage';

type BackgroundOverlayImageProps = {
  height?: string;
  customGradient?: string;
};

const BackgroundOverlayImage = ({
  height = '32rem',
  customGradient
}: BackgroundOverlayImageProps) => {
  const { imgURL, altText } = useBrandImage();

  const gradient =
    customGradient ??
    'to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)';

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: height,
        backgroundColor: SOY,
        backgroundImage: `linear-gradient(${gradient}), url(${imgURL})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        zIndex: '-1'
      }}
    >
      {/* Invisible image for alt text */}
      <img
        src={imgURL}
        alt={altText}
        style={{ display: 'none' }}
        data-testid="brand-overlay-image"
      />
    </Box>
  );
};

export default BackgroundOverlayImage;
